"use strict";

import module from "./module";
import "./sachberichtvorlagen.spec";

export default module;
